import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { Message } from '@axo/ui-core/components/Message';
import { USPsList } from '@axo/ui-feature/components/USPsList';
import { useFormContext } from 'react-hook-form';
import { Trans } from 'react-i18next';
import { Step6Data } from '../../../FormData.fi.types';
import { radioOptions } from '../../config/globals';
import { gridColumns } from '../../config/layouts/grid';
import { CoAppFormGroup } from './CoAppFormGroup';

export const CoApplicant = () => {
  const { t } = useTranslation();

  const { watch } = useFormContext();

  const keyBenefits = t('AddCoApplicant.KeyBenefits', {
    returnObjects: true,
    defaultValue: [],
  }) as string[];

  const addCoApplicant = watch('Frontend/AddCoApplicant');

  return (
    <>
      <USPsList gap="3xs" title={t('AddCoApplicant.title')}>
        {keyBenefits?.map((benefit, index) => (
          <USPsList.Item key={index}>
            <Trans t={t}>{benefit}</Trans>
          </USPsList.Item>
        ))}
      </USPsList>

      <Grid columns={gridColumns}>
        <RadioFieldUI<Step6Data>
          name="Frontend/AddCoApplicant"
          label={t('AddCoApplicant.label')}
          data-testid="add-co-applicant-input"
          radioStyle="both"
          options={radioOptions}
        />
      </Grid>

      {addCoApplicant === 'No' && (
        <Message variant="info">{t('AddCoApplicant.info')}</Message>
      )}

      {addCoApplicant === 'Yes' && <CoAppFormGroup />}
    </>
  );
};
